export const LexxApplication = {
  VOUSER: "vanoord",
  VOADMIN: "vanoord-admin",
  ALL: "all"
};
